import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";

const ForgotPasswordForm = () => {
  const [formData, setFormData] = useState({
    email: "",
  });

  const [errors, setErrors] = useState({
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Basic email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim()); // Trim spaces before validation
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    let validationErrors = {};

    // Email validation
    if (!formData.email.trim()) {
      validationErrors.email = "Email is required.";
    } else if (!validateEmail(formData.email)) {
      validationErrors.email = "Please enter a valid email address.";
    }

    // If there are validation errors, update state and prevent form submission
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Simulate password reset action
    alert("Password reset link has been sent to your email.");

    // After successful submission, you can navigate or reset form if needed
  };

  return (
    <div className="login-box">
      <h2>Forgot Password</h2>
      <p>Enter your email address to receive a password reset link.</p>
      <Form onSubmit={handleForgotPassword} className="form login-form">
        <Form.Group className="mb-4">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="text"
            name="email"
            placeholder="Enter your email address"
            value={formData.email}
            onChange={handleChange}
            isInvalid={!!errors.email}
          />
          <Form.Control.Feedback type="invalid">
            {errors.email}
          </Form.Control.Feedback>
        </Form.Group>

        <Button type="submit" className="full-btn sign-in-btn w-100">
          Send Reset Link
        </Button>

        <p className="mt-3 text-center">
          <Link to="/login">Back to Login</Link>
        </p>
      </Form>
    </div>
  );
};

export default ForgotPasswordForm;
